/* eslint-disable import/no-extraneous-dependencies */
import { Attributes } from '@leverege/ui-attributes'
import { Content, Pane, SplitPane, TableV2, Text } from '@leverege/ui-elements'
import { LinearView, MomentBackground, MomentHeader, ScrollSync } from '@leverege/ui-linear-view-elements'
import { GlobalState, Selection } from '@leverege/ui-redux'
import React from 'react'
import LinearViewBlock from './LinearViewBlock'

import OperatingHours from './OperatingHours'
import S from './TableSplitView.css'

const columns = [
  { Header : 'Name', accessor : obj => Attributes.get( 'name', obj ) }
]

const DEFAULT_STYLE = {
  height : '100%',
  marginTop : 0
}

export default class TableSplitView extends React.Component {

  constructor( props ) {
    super( props )
    this.syncRef = React.createRef()
    this.scrollRef = React.createRef()
    this.headerRef = React.createRef()
    this.linearViewRef = React.createRef()
    this.state = {
      style : {
        table : DEFAULT_STYLE,
        lv : DEFAULT_STYLE
      },
      lvHeaderHeight : 0,
      tableHeaderHeight : 0
    }
  }

  onScroll = ( evt ) => { 
    if ( this.syncRef.current ) {
      this.syncRef.current.onScroll( evt )
    }
  }

  blockStylizer = ( item, projection, startValue, stopValue, x1, x2 ) => {
    return {
      component : LinearViewBlock,
      componentProps : {
        variant : 'linearViewBlock',
        item,
        x1,
        x2
      },
      style : {
        zIndex : 2
      }
    }
  }

  onHeaderHeightChange = ( height ) => {
    const { lvHeaderHeight, tableHeaderHeight } = this.state

    const th = this.headerRef && this.headerRef.current ? this.headerRef.current.clientHeight : 0

    if ( th > height ) {
      if ( th !== tableHeaderHeight ) {
        const mt = `${th - height}px`
        this.setState( {
          style : {
            lv : {
              height : `calc(100% - ${mt})`
            },
            table : DEFAULT_STYLE
          },
          tableHeaderHeight : th
        } )
      }
    } else if ( height !== lvHeaderHeight ) {
      const rh = this.headerRef && this.headerRef.current ? this.headerRef.current.clientHeight : 0
      const mt = `${height - rh}px`
      this.setState( { 
        style : { 
          table : {
            height : `calc(100% - ${mt})`,
            marginTop : height - rh
          },
          lv : DEFAULT_STYLE
        }, 
        lvHeaderHeight : height
      } )
    }
  }

  onRollover = ( i ) => {
    const { entered, data } = i

    if ( entered ) {
      GlobalState.dispatch( Selection.set( 'rollover', { id : data.id } ) )
    } else {
      GlobalState.dispatch( Selection.clear( 'rollover' ) )
    }
  }

  onClick = ( i ) => {
    const { selected } = this.props

    const { data } = i
    const hasSelection = !Selection.isEmpty( selected )

    if ( hasSelection ) {
      GlobalState.dispatch( Selection.clear( 'selected' ) )
    } else {
      GlobalState.dispatch( Selection.set( 'selected', { id : data.id } ) )
    }
  }

  render() {
    const { style } = this.state
    const { headerData, rows, projection, operatingHours, operatingHoursMargin } = this.props

    return (
      <Content horizontal>
        <Content.Area>
          <SplitPane>
            <div style={{ overflow : 'hidden' }}>
              <ScrollSync 
                onHeaderHeightChange={this.onHeaderHeightChange}
                ref={this.syncRef}
                scrollRef={this.scrollRef}
                headerRef={this.headerRef}
                linearViewRef={this.linearViewRef} >
                <TableV2
                  variant="timeline"
                  paginate={false}
                  style={style.table}
                  onScroll={this.onScroll}
                  tableRef={this.scrollRef}
                  headerRef={this.headerRef}
                  getRowProps={( row, props ) => { return { ...props, style : { height : '40px' } } }}
                  data={headerData} 
                  columns={columns} />
              </ScrollSync>
            </div>
            <div style={{ position : 'relative' }}>
              <LinearView
                style={style.lv}
                onRollover={this.onRollover}
                onClick={this.onClick}
                ref={this.linearViewRef}
                projection={projection}
                data={rows}
                scrollRef={this.syncRef}
                rowComponent={Pane}
                rowClass={S.row}
                rowProps={{ variant : 'linearViewRow', width : '100%' }}
                blockStylizer={this.blockStylizer}
                startAccess={getStart}
                stopAccess={getStop}
                extraContent={(
                  <OperatingHours
                    key="oh"
                    numRows={rows.length}
                    projection={projection}
                    operatingHours={operatingHours}
                    operatingHoursMargin={operatingHoursMargin} />
                )}>
                <MomentBackground
                  projection={projection}
                  unit="hour"/>
                <MomentHeader
                  fillWidth
                  cellComponent={Pane}
                  cellComponentProps={{ variant : 'linearViewHeaderCell1' }}
                  labelComponent={Text}
                  labelComponentProps={{ variant : 'linearViewHeaderCell1' }}
                  projection={projection} 
                  unit="day" 
                  format="MMM DD" 
                  sticky/>
                <MomentHeader
                  fillWidth
                  cellComponent={Pane}
                  cellComponentProps={{ variant : 'linearViewHeaderCell2' }}
                  labelComponent={Text}
                  labelComponentProps={{ variant : 'linearViewHeaderCell2' }}
                  projection={projection} 
                  unit="hour" 
                  format="h A" 
                  sticky/>
              </LinearView>
            </div>
          </SplitPane>
        </Content.Area>
      </Content>
    )
  }
}

function getStart( i ) {
  return i.startTime
}
function getStop( i ) {
  return i.stopTime
}
